export default __webpack_public_path__ + "static/media/ic_glp_24.498943f1.svg";